
// import CalendarTodayOutlinedIcon from '@material-ui/icons/CalendarTodayOutlined';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
// import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import AssignmentTurnedInOutlinedIcon from '@material-ui/icons/AssignmentTurnedInOutlined';
import BarChartOutlinedIcon from '@material-ui/icons/BarChartOutlined';
import BeenhereOutlinedIcon from '@material-ui/icons/BeenhereOutlined';
import CardGiftcardIcon from '@material-ui/icons/CardGiftcard';
import ImportContactsOutlinedIcon from '@material-ui/icons/ImportContactsOutlined';
import PeopleAltOutlinedIcon from '@material-ui/icons/PeopleAltOutlined';
import TrackChangesOutlinedIcon from '@material-ui/icons/TrackChangesOutlined';
import WhatshotOutlinedIcon from '@material-ui/icons/WhatshotOutlined';
import {
    Box,
    Button,
    Card,
    CardContent,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Alert as MuiAlert,
    Snackbar,
    TextField,
    Typography
} from "@mui/material";
import axios from 'axios';
import { configUrl } from 'config';
import { useState } from 'react';
const features = [
    { icon: PeopleAltOutlinedIcon, title: 'Career Counselling', description: 'Get expert guidance on career paths, course selection, and future opportunities', color: 'linear-gradient(to bottom right, #3c83f6, #3c83f6);' },
    { icon: TrackChangesOutlinedIcon, title: 'Academic Mentorship', description: 'One-on-one mentoring sessions to help you excel in your studies and exams', color: 'linear-gradient(to bottom right, #7c3bed, #7c3bed);' },
    { icon: ImportContactsOutlinedIcon, title: 'Study Strategy', description: 'Personalized study plans and techniques tailored to your learning style', color: 'linear-gradient(to bottom right, #f59f0a, #f59f0a);' },
    { icon: BeenhereOutlinedIcon, title: 'Goal Achievement', description: 'Set and achieve your academic and career goals with expert support', color: 'linear-gradient(to bottom right, #10b77f, #10b77f);' },
];

const MentorSection = ({ isLoggedIn, setShowForm }) => {

    // const [price] = useState(subscription?.price ?? 0);
    const [showCheckout, setShowCheckout] = useState(false);

    const [branchOptions, setBranchOptions] = useState([
        "AI & Data Science",
        "Aeronautical & Automotive",
        "Architectural & Planning",
        "Biomedical & Biotechnology",
        "Civil",
        "Computer",
        "Electrical & Electronics",
        "Mechanical",
        "Pharmaceutical & Oil",
        "Information Technology"
    ]);
    const [cityOptions, setCityOptions] = useState([
        "Ahmednagar",
        "Amravati",
        "Aurangabad",
        "Jalgaon",
        "Kolhapur",
        "Mumbai",
        "Nagpur",
        "Nanded",
        "Nandurbar",
        "Nashik",
        "Navi Mumbai",
        "Parbhani",
        "Pune",
        "Raigad",
        "Ratnagiri",
        "Satara",
        "Shirpur",
        "Solapur",
        "Thane",
        "Wardha"
    ]);
    const [loading, setLoading] = useState(false)

    const [rank, setRank] = useState("");
    const [preferredBranch, setPreferredBranch] = useState("");
    const [locationPreference, setLocationPreference] = useState("");
    const [openForm, setOpenForm] = useState(false);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [mobile, setMobile] = useState("");
    const [open, setOpen] = useState(false);
    const [showError, setShowError] = useState([]);
    const [severty, setSeverty] = useState('warning');
    const [colleges] = useState([
        {
            "College Code": 3012,
            "Branch Code": "301224510",
            "Category": "GOBCS",
            "Branch": "Computer Engineering",
            "City": "Mumbai",
            "College": "Veermata Jijabai Technological Institute(VJTI), Matunga, Mumbai",
            "Highest Rank": 667,
            "Percentile": 99.7498822,
            "Rank": 667,
            "Round": 2,
            "Round 1 Percentile": 99.8171846,
            "Round 1 Rank": 468,
            "Round 2 Percentile": 99.7498822,
            "Round 2 Rank": 667,
            "Stage": "I",
            "SI": 60,
            "Highest Percentile": 99.8171846,
            "AbbreviatedName": "VJTI, Mumbai"
        },
        {
            "College Code": 16006,
            "Branch Code": "1600661210",
            "Category": "GOPENS",
            "Branch": "Mechanical Engineering",
            "City": "Pune",
            "College": "COEP Technological University",
            "Highest Rank": 2044,
            "Percentile": 99.3496503,
            "Rank": 2044,
            "Round": 2,
            "Round 1 Percentile": 99.4352449,
            "Round 1 Rank": 1756,
            "Round 2 Percentile": 99.3496503,
            "Round 2 Rank": 2044,
            "Stage": "I",
            "SI": 150,
            "Highest Percentile": 99.4352449,
            "AbbreviatedName": "COEP, Pune"
        },
        {
            "College Code": 3014,
            "Branch Code": "301461210",
            "Category": "GOPENS",
            "Branch": "Mechanical Engineering",
            "City": "Andheri",
            "College": "Sardar Patel College of Engineering, Andheri",
            "Highest Rank": 3122,
            "Percentile": 99.1923077,
            "Rank": 2612,
            "Round": 2,
            "Round 1 Percentile": 99.0517692,
            "Round 1 Rank": 3122,
            "Round 2 Percentile": 99.1923077,
            "Round 2 Rank": 2612,
            "Stage": "I",
            "SI": 60,
            "Highest Percentile": 99.1923077,
            "AbbreviatedName": "Sardar Patel College, Andheri"
        }
    ])
    const [loadingSignUp, setSignUpLoading] = useState(false);

    // Validation logic
    const validateFields = () => {
        const trimmedName = name.trim();
        const trimmedEmail = email.trim();
        const trimmedMobile = mobile.trim();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const mobileRegex = /^[0-9]{10}$/;
        if (!trimmedName) {
            setShowError("Name is required");
            setSeverty("error");
            setOpen(true);
            return false;
        }
        else if (!trimmedEmail) {
            setShowError("Email is required");
            setSeverty("error");
            setOpen(true);
            return false;
        } else if (!emailRegex.test(trimmedEmail)) {
            setShowError("Enter a valid email address");
            setSeverty("error");
            setOpen(true);
            return false;
        }

        if (trimmedMobile && !mobileRegex.test(trimmedMobile)) {
            setShowError("Enter a valid 10-digit mobile number");
            setSeverty("error");
            setOpen(true);
            return false;
        }

        return true;
    };



    const handleClose = (event, reason) => {
        if (reason === 'clickaway') return;
        setOpen(false);
        setShowError("");
    };
    const onNextHandle = async () => {
        setSignUpLoading(true);
        // const subscription = await getAllSubscriptionsService();
        // console.log(subscription, '-subs respincp')
        // const series = {
        //     subscriptionTypeId: subscription[1]?.subscriptionTypeId,
        //     courseId: subscription[1]?.subscriptionTypeId ?? 0,
        //     price: subscription[1]?.price ?? 0,
        // };
        // const ResourceTypeId = 4;
        // if (isLoggedIn) {
        //     setShowCheckout(true);
        // } else {
        //     handleShowSubcription('#college-predictor');
        //     navigate("/medineer/SignUp", { state: { series, ResourceTypeId } });
        // }
        // setSignUpLoading(false);
    };

    const onPredictClick = () => {
        if (!rank || !preferredBranch || !locationPreference) {
            setOpen(true);
            setShowError("Please fill Percentile, Branch, and Location first");
            setSeverty('error');
            setLoading(false);
            return;
        }
        setOpenForm(true);
    };

    const handleSubmit = async () => {
        if (validateFields()) {
            let FeatureKey = "college_predictor"
            const payload = {
                "Name": name,
                "Email": email,
                "Mobile": mobile,
                FeatureKey,
                "Percentile": rank,
                "Branch": preferredBranch,
                "City": locationPreference
            };

            try {
                setLoading(true);
                let resp = await axios.post(`${configUrl.AssessmentServer}/api/User/FeatureRecord`, payload);
                if (resp.data?.allowed == true) {
                    setOpen(true);
                    setShowError("Thanks! Please check your email for your personalized college list.");
                    setSeverty('success');
                } else {
                    setOpen(true);
                    setShowError("Oh! Please subscribe to the College Predictor feature to receive updates and alerts throughout the admission process.");
                    setSeverty('warning');
                }
                setLoading(false);
                setOpenForm(false);
                setName(null);
                setMobile(null);
                setEmail(null);
                setRank("")
                setPreferredBranch(null)
                setLocationPreference(null)

            } catch (error) {
                console.error("Error saving data:", error);
                // alert("Something went wrong.");
                setOpen(true);
                setShowError("Something went wrong.");
                setSeverty('error');
                setLoading(false);
            }
        }
    };



    // useEffect(() => {
    //     const fetchFilters = async () => {
    //         try {
    //             const response = await axios.get(`${configUrl.PredictorServer}/getFilters`);
    //             const data = response.data;

    //             const uniqueBranches = Array.from(new Set(data?.branches || []));
    //             setBranchOptions(uniqueBranches);
    //             setCityOptions(data?.cities || []);
    //         } catch (error) {
    //             console.error("Error fetching filter options:", error);
    //         }
    //     };
    //     fetchFilters();
    // }, []);

    return (
        <Box
            id="predictor"
            sx={{
                position: "relative",
                py: { xs: 6, md: 8 },
                bgcolor: "white",
                overflow: "hidden",
            }}
        >
            {/* Background Circles */}
            <Box
                sx={{
                    position: "absolute",
                    top: -100,
                    left: -100,
                    width: 300,
                    height: 300,
                    borderRadius: "50%",
                    backgroundColor: "primary.main",
                    opacity: 0.1,
                    filter: "blur(100px)",
                }}
            />
            <Box
                sx={{
                    position: "absolute",
                    bottom: -100,
                    right: -100,
                    width: 300,
                    height: 300,
                    borderRadius: "50%",
                    backgroundColor: "secondary.main",
                    opacity: 0.1,
                    filter: "blur(100px)",
                }}
            />

            <Box sx={{ position: "relative", zIndex: 2, px: 2, maxWidth: 1200, mx: "auto" }}>
                <Grid container spacing={6}>
                    {/* LEFT SECTION */}
                    <Grid item xs={12} md={6} alignContent={'center'}>
                        <Grid container spacing={2}>
                            {features.map((feature, index) => (
                                <Grid item xs={12} md={6} lg={6} key={index}>
                                    <Card sx={{
                                        textAlign: 'left',
                                        boxShadow: 'none',
                                        borderRadius: '1rem',
                                        height: '100%',
                                        transition: 'all 0.3s ease',
                                        border: '1px solid #d1d9e0',
                                        '&:hover': {
                                            transform: 'translateY(-8px)',
                                            boxShadow: 6
                                        }
                                    }}>
                                        <CardContent sx={{ p: 2 }}>
                                            <Box sx={{ width: 41, height: 41, borderRadius: 2, background: `${feature.color}`, display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3, transition: 'transform 0.3s ease', '&:hover': { transform: 'scale(1.1)' } }}>
                                                <feature.icon htmlColor='#fff' sx={{ fontSize: 28 }} />
                                            </Box>
                                            <Typography variant="h5"
                                                sx={{
                                                    // mb: 2,
                                                    fontWeight: 600,
                                                    fontSize: '1rem',
                                                    lineHeight: '2rem',
                                                    color: '#0f1a24',
                                                    fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                                                }}>
                                                {feature.title}
                                            </Typography>
                                            <Typography color="text.secondary"
                                                sx={{
                                                    fontWeight: 400,
                                                    fontSize: '0.75rem',
                                                    lineHeight: '1.25rem',
                                                    color: '#52667a',
                                                    fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                                                }}>
                                                {feature.description}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>


                    {/* RIGHT SECTION */}
                    <Grid item xs={12} md={6}>
                        <Box sx={{
                            display: "inline-flex", alignItems: "center", gap: 1.5, mb: 2, bgcolor: "#7c3bed1a", px: 2, py: 1, borderRadius: 5,
                        }}>
                            <WhatshotOutlinedIcon size={20} />
                            <Typography sx={{
                                fontSize: '0.875rem',
                                lineHeight: '1.25rem',
                                color: '#7c3bed',
                                fontWeight: '600',
                                fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                            }} fontWeight={600}>

                                Premium Mentorship
                            </Typography>
                        </Box>

                        <Typography
                            variant="h3"
                            sx={{
                                fontSize: '2.2rem',
                                textAlign: 'left',
                                fontWeight: 700,
                                mb: 2,
                                lineHeight: 1.2,
                                color: "#242e42",
                                fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                                background: "linear-gradient(to right, hsl(262 83% 58%), hsl(38 92% 50%))",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                            }}
                        >
                            Empower students. Make an impact. Earn from home.
                        </Typography>

                        <Typography variant="h6" mb={4} sx={{ fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"', color: '#65758b', fontWeight: '400', fontSize: '0.98rem', lineHeight: '1.625rem', color: '#6c7993', textAlign: 'left', textTransform: 'none' }}>
                            <Box component="span" sx={{ color: "hsl(262 83% 58%)", fontWeight: '600' }}>
                                Join the MEDINEER Mentor Network today
                            </Box>{" "}
                            — a meaningful opportunity for teachers, homemakers, and retired professionals to guide students preparing for engineering and medical entrance exams. With EdTect's complete ecosystem, you get all the tools and support to mentor confidently and <Box component="span" sx={{ color: "hsl(262 83% 58%)", fontWeight: '600' }}> grow steadily </Box>.
                        </Typography>

                        <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
                            {[
                                {
                                    icon: <AssignmentTurnedInOutlinedIcon sx={{ color: '#13ACCA', fontSize: '2rem' }} />,
                                    title: "Complete Support Kit",
                                    desc: "Get access to digital study materials, online test series, and counselling tools.",
                                    bgcolor: '#7c3bed'
                                },
                                {
                                    icon: <BarChartOutlinedIcon sx={{ color: "#FFCD35", fontSize: '2rem' }} />,
                                    title: "Smart Dashboard",
                                    desc: "Track student progress, monitor performance, and send reminders with ease.",
                                    bgcolor: '#f59f0a'
                                },
                                // {
                                //     icon: <AssistantIcon sx={{ color: "#F4743D", fontSize: '2rem' }} />,
                                //     title: "Strategic College Planning",
                                //     desc: "Optimize your college admission strategy.",
                                //     bgcolor: '#e7eff5'
                                // },
                                {
                                    icon: <CardGiftcardIcon sx={{ color: "#F4743D", fontSize: '2rem' }} />,
                                    title: "Earn with Purpose",
                                    desc: "Create social impact while building a flexible, sustainable source of income.",
                                    bgcolor: '#3c83f6'
                                },
                            ].map((item, i) => (
                                <Box key={i} sx={{ display: "flex", gap: 2, textAlign: 'left' }}>
                                    <Box
                                        sx={{
                                            p: 1,
                                            borderRadius: "25%",
                                            bgcolor: item.bgcolor, //"grey.100",
                                            height: 36,
                                            width: 36,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            color: '#fff'
                                        }}
                                    >
                                        {item.icon}
                                    </Box>
                                    <Box>
                                        <Typography fontWeight={600} sx={{
                                            fontWeight: 600,
                                            fontSize: '0.875rem',
                                            lineHeight: '1.25rem',
                                            color: '#242e42'
                                        }}>{item.title}</Typography>
                                        <Typography variant="body2" sx={{
                                            fontWeight: 400,
                                            fontSize: '0.875rem',
                                            lineHeight: '1.25rem',
                                            color: '#52667a',
                                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                                        }}>
                                            {item.desc}
                                        </Typography>
                                    </Box>
                                </Box>
                            ))}
                        </Box>

                        <Button
                            variant="contained"
                            size="large"
                            // endIcon={<CheckCircleOutlinedIcon />}
                            sx={{
                                mt: 4,
                                borderRadius: 3,
                                textTransform: "none",
                                fontWeight: 600,
                                fontSize: '1.4rem',
                                background: 'linear-gradient(135deg, hsl(16 100% 62%) 0%, #f59f0a 100%)',
                                color: '#fff',
                                float: 'left',
                                fontSize: '0.875rem',
                                lineHeight: '1.25rem',
                            }}
                            onClick={setShowForm}
                        >
                            {loadingSignUp ? 'Loading...' : '💼 Join as a Mentor Today'}
                        </Button>
                    </Grid>
                </Grid>
            </Box>
            <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "center" }} open={open} onClose={handleClose} autoHideDuration={3000}>
                <MuiAlert
                    severity={severty} //"error"
                    onClose={handleClose}
                    sx={{
                        fontSize: "15px",
                        width: "100%",
                        //  backgroundColor: '#f69d9dff', 
                        color: '#000'
                    }}
                >
                    {showError}
                </MuiAlert>
            </Snackbar>
            <Dialog open={openForm} onClose={() => setOpenForm(false)} maxWidth="sm" fullWidth>
                <DialogTitle
                    sx={{
                        fontWeight: 700,
                        fontSize: "1.8rem",
                        fontFamily:
                            'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                        backgroundColor: "#0B3054", // dark blue
                        color: "#fff",
                        textAlign: "left",
                        py: 2,
                        display: 'inline-flex',
                        alignItem: 'center'
                    }}
                >
                    <Box
                        sx={{
                            background: 'linear-gradient(135deg, hsl(38 100% 50%), hsl(14 100% 60%))', // orange background
                            borderRadius: 2,
                            width: 42,
                            height: 42,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: '1rem'
                        }}
                    >
                        <DescriptionOutlinedIcon sx={{ color: "#0B3054", fontSize: '2.5rem' }} />
                    </Box>
                    <Box>
                        Get Your College List
                    </Box>
                </DialogTitle>

                <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
                    {/* Subtext */}
                    <Typography
                        variant="body1"
                        sx={{
                            mb: 2,
                            textAlign: "left",
                            fontSize: "2rem",
                            color: "#4a4a4a",
                            fontWeight: '600',
                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                        }}
                    >
                        Get your college list by email—just fill in your details.
                    </Typography>
                    <TextField
                        label="Name"
                        fullWidth
                        required
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        sx={{
                            mb: 1,
                            fontSize: "1.1rem",
                            "& .MuiFormHelperText-root": {
                                fontSize: "1rem", // Increased helper text size
                            },
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "0.75rem", // Apply border radius to the input field
                                backgroundColor: "#F8F9FB", // Input background color
                                fontSize: "1.5rem", // Increase the input text size
                            },
                            "& .MuiInputLabel-root": {
                                fontSize: "1.5rem", // Increase the label text size
                            },
                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                        }}
                        InputProps={{ style: { fontSize: "1.5rem" } }}
                    />

                    <TextField
                        label="Email"
                        type="email"
                        required
                        fullWidth
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        sx={{
                            mb: 1,
                            fontSize: "1.1rem",
                            "& .MuiFormHelperText-root": {
                                fontSize: "1rem", // Increased helper text size
                            },
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "0.75rem", // Apply border radius to the input field
                                backgroundColor: "#F8F9FB", // Input background color
                                fontSize: "1.5rem", // Increase the input text size
                            },
                            "& .MuiInputLabel-root": {
                                fontSize: "1.5rem", // Increase the label text size
                            },
                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                        }}
                        InputProps={{ style: { fontSize: "1.5rem" } }}
                    />

                    <TextField
                        label="Mobile"
                        fullWidth
                        value={mobile}
                        onChange={(e) => setMobile(e.target.value)}
                        sx={{
                            mb: 1,
                            fontSize: "1.1rem",
                            "& .MuiFormHelperText-root": {
                                fontSize: "1rem", // Increased helper text size
                            },
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "0.75rem", // Apply border radius to the input field
                                backgroundColor: "#F8F9FB", // Input background color
                                fontSize: "1.5rem", // Increase the input text size
                            },
                            "& .MuiInputLabel-root": {
                                fontSize: "1.5rem", // Increase the label text size
                            },
                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                        }}
                        InputProps={{ style: { fontSize: "1.5rem" } }}
                    />

                </DialogContent>

                <DialogActions sx={{ px: 3, pb: 3 }}>
                    <Button
                        onClick={() => setOpenForm(false)}
                        variant="outlined"
                        // sx={{ textTransform: "none" }}
                        // variant="contained"
                        size="large"
                        sx={{
                            mt: 2,
                            borderRadius: 3,
                            border: '1px solid #0B3054',
                            textTransform: "none",
                            fontWeight: 600,
                            padding: '0.75rem 2rem',
                            fontSize: '1.4rem',
                            color: '#0B3054',
                            // background: '#0B3054',
                        }}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        size="large"
                        disabled={loading}
                        sx={{
                            mt: 2,
                            borderRadius: 3,
                            textTransform: "none",
                            fontWeight: 600,
                            padding: '0.75rem 2rem',
                            fontSize: '1.4rem',
                            color: '#fff',
                            background: '#0B3054',
                            '&:disabled': { backgroundColor: '#0B3054a1' }
                        }}
                        onClick={() => handleSubmit()}
                    >
                        {loading ? 'Loading...' :
                            "Submit"}
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};
export default MentorSection;


